import { useCallback } from 'react';
import { DRAG_EVENT_KEY, UNFILED_ASSETS_ID } from 'framework-listing-lib/internal/Folders/constants/folders';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import { useDraggedObject } from '../providers/DragProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DraggableTableRowV2({
  crmObject,
  isSelected,
  rowProps,
  selectedIds,
  selectionMode
}) {
  const {
    setCurrentDragData
  } = useDraggedObject();
  const handleOnDrag = useCallback(e => {
    const folderIdPropValue = getPropertyValue(crmObject, 'hs_folder_id', '-1');

    // Some objects have the property but its value is an empty string or '0'
    const intFolderId = parseInt(folderIdPropValue || '-1', 10) || UNFILED_ASSETS_ID;
    const dragData = {
      isSelected,
      objectId: crmObject.objectId,
      previousFolderId: intFolderId,
      selectedIds,
      selectionMode
    };
    e.dataTransfer.setData(DRAG_EVENT_KEY, JSON.stringify(dragData));
    setCurrentDragData({
      previousFolderId: intFolderId,
      selectionMode
    });
  }, [crmObject, isSelected, selectedIds, selectionMode, setCurrentDragData]);
  return /*#__PURE__*/_jsx("tr", Object.assign({}, rowProps, {
    draggable: true,
    onDragStart: handleOnDrag,
    style: Object.assign({}, rowProps.style || {}, {
      cursor: 'move'
    })
  }));
}